import { useEffect } from 'react';
import { userLogout } from "../../util/core/Session";
import { useDispatch } from 'react-redux';

function Logout() {
    const dispatch = useDispatch();
    useEffect(() => {
        userLogout();
        dispatch({ type: 'CLEAR_DATA'});
        window.location.href = `/login`;
    });
}

export default Logout;
